import {webSettingsConstants} from "../../../../constants/Web/webSettings.constants";

// Proje zarfi: { status: 200, error: false, message, data }
// Basari "status === 1" ile DEGIL, error bayragiyla anlasilir.
const isOk = (payload) => !!payload && payload.error === false;

const initialState = {
    fetching: false,
    settings: null,
    error: false,

    updateFetching: false,
    updateData: null,
    updateError: false,
};

export default function (state = initialState, action) {
    switch (action.type) {

        // --- Ayarlari oku ---
        case webSettingsConstants.WEB_SETTINGS_GET_PENDING:
            return {
                ...state,
                fetching: true,
                error: false,
            };
        case webSettingsConstants.WEB_SETTINGS_GET_FULFILLED:
            return {
                ...state,
                fetching: false,
                error: isOk(action.payload) ? false : action.payload,
                // Hic ayar yoksa servis bos nesne doner
                settings: isOk(action.payload) ? (action.payload.data || {}) : state.settings,
            };
        case webSettingsConstants.WEB_SETTINGS_GET_REJECTED:
            return {
                ...state,
                fetching: false,
                error: action.payload,
            };

        // --- Ayar guncelle (kismi) ---
        case webSettingsConstants.WEB_SETTINGS_UPDATE_PENDING:
            return {
                ...state,
                updateFetching: true,
                updateData: null,
                updateError: false,
            };
        case webSettingsConstants.WEB_SETTINGS_UPDATE_FULFILLED:
            // HTTP 200 ama error:true olabilir (orn. gecersiz telefon) — hata sayilir
            if (!isOk(action.payload)) {
                return {
                    ...state,
                    updateFetching: false,
                    updateData: null,
                    updateError: action.payload,
                };
            }
            return {
                ...state,
                updateFetching: false,
                updateError: false,
                updateData: action.payload,
                // update guncel TAM seti donuyor
                settings: action.payload.data || state.settings,
            };
        case webSettingsConstants.WEB_SETTINGS_UPDATE_REJECTED:
            return {
                ...state,
                updateFetching: false,
                updateError: action.payload,
            };

        case webSettingsConstants.WEB_SETTINGS_UPDATE_CLEAR:
            return {
                ...state,
                updateData: null,
                updateError: false,
            };

        default:
            return state;
    }
}
